import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type CloseUpsProps = {
    className?: string;
};

const CloseUps: FunctionComponent<CloseUpsProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'close-ups'}
            viewBox="0 0 250 250"
        >
            <path
                fill="none"
                d="M9 200.7l45.6-33.5 11.2 11.2 51.2-43.2 71.9 54.5V130c-8.7 6.1-19.3 9.6-30.6 9.6-29.6 0-53.7-24.1-53.7-53.7 0-1.3.1-2.6.2-3.9H9v118.7zM46.7 98.6c13 0 23.5 10.5 23.5 23.5s-10.5 23.5-23.5 23.5-23.5-10.6-23.5-23.5c0-13 10.5-23.5 23.5-23.5z"
            />
            <path
                fill="none"
                d="M46.7 136.5c8 0 14.5-6.5 14.5-14.5s-6.5-14.5-14.5-14.5S32.2 114 32.2 122s6.5 14.5 14.5 14.5z"
            />
            <path
                fill="none"
                d="M158.4 41.2c-20.1 0-37.2 13.4-42.8 31.7-.9 2.9-1.5 5.9-1.7 9-.1 1.3-.2 2.6-.2 3.9 0 24.6 20.1 44.7 44.7 44.7 11.9 0 22.6-4.6 30.6-12.2.6-.5 1.1-1.1 1.7-1.6.1-.1.2-.2.3-.4l.2-.2c2.7-2.9 5-6.2 6.9-9.8 3.2-6.2 5-13.1 5-20.6 0-24.5-20.1-44.5-44.7-44.5z"
            />
            <path
                fill="none"
                d="M9 200.7l45.6-33.5 11.2 11.2 51.2-43.2 71.9 54.5V130c-8.7 6.1-19.3 9.6-30.6 9.6-29.6 0-53.7-24.1-53.7-53.7 0-1.3.1-2.6.2-3.9H9v118.7z"
            />
            <path
                fill="none"
                d="M158.4 41.2c-20.1 0-37.2 13.4-42.8 31.7-.9 2.9-1.5 5.9-1.7 9-.1 1.3-.2 2.6-.2 3.9 0 24.6 20.1 44.7 44.7 44.7 11.9 0 22.6-4.6 30.6-12.2.6-.5 1.1-1.1 1.7-1.6.1-.1.2-.2.3-.4l.2-.2c2.7-2.9 5-6.2 6.9-9.8 3.2-6.2 5-13.1 5-20.6 0-24.5-20.1-44.5-44.7-44.5z"
            />
            <path d="M46.7 98.6c-13 0-23.5 10.5-23.5 23.5s10.5 23.5 23.5 23.5 23.5-10.5 23.5-23.5-10.6-23.5-23.5-23.5zm0 37.9c-8 0-14.5-6.5-14.5-14.5s6.5-14.5 14.5-14.5S61.2 114 61.2 122s-6.5 14.5-14.5 14.5z" />
            <path d="M248.7 167.7l-48.3-48.3c7.3-9.2 11.8-20.8 11.8-33.5 0-29.6-24.1-53.7-53.7-53.7-25.2 0-46.3 17.4-52.1 40.8H0v144.9h198v-88l44.2 44.2c.9.9 2 1.3 3.2 1.3s2.3-.4 3.2-1.3c1.8-1.8 1.8-4.6.1-6.4zM189 208.8H13.3l40.5-29.7 11.6 11.6 52-43.9L189 201v7.8zm0-19.1l-71.9-54.5-51.2 43.2-11.2-11.2L9 200.7V82h95.7c-.1 1.3-.2 2.6-.2 3.9 0 29.6 24.1 53.7 53.7 53.7 11.4 0 21.9-3.6 30.6-9.6v59.7zm2.2-73.5c-.1.1-.2.1-.2.2-.1.1-.2.2-.3.4-.5.6-1.1 1.1-1.7 1.6a44.3 44.3 0 0 1-30.6 12.2c-24.6 0-44.7-20.1-44.7-44.7 0-1.3.1-2.6.2-3.9.3-3.1.9-6.1 1.7-9 5.6-18.3 22.6-31.7 42.8-31.7 24.6 0 44.7 20.1 44.7 44.7 0 7.4-1.8 14.4-5 20.6-1.9 3.4-4.2 6.7-6.9 9.6z" />
            <polygon
                fill="none"
                points="65.4,190.7 53.8,179.1 13.3,208.8 189,208.8 189,201.1 117.4,146.8"
            />
            <polygon
                fill="none"
                points="65.4,190.7 53.8,179.1 13.3,208.8 189,208.8 189,201.1 117.4,146.8"
            />
        </svg>
    );
};
export default CloseUps;
